import { render, staticRenderFns } from "./CoursewareIndex.vue?vue&type=template&id=e5288236&scoped=true&"
import script from "./CoursewareIndex.vue?vue&type=script&lang=js&"
export * from "./CoursewareIndex.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareIndex.vue?vue&type=style&index=0&id=e5288236&lang=scss&scoped=true&"
import style1 from "./CoursewareIndex.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5288236",
  null
  
)

export default component.exports